import axios from 'axios'
import { requestInterceptor } from 'shared/infrastructure/interceptors/interceptors'

const partnerApiClient = http => {
  const client = http.create({
    baseURL: `${process.env.API_GATEWAY}/partner`,
    headers: {
      Accept: `application/vnd.creditas.${process.env.PARTNER_ACCEPT_VERSION}+json`,
      'Content-Type': 'application/json',
      'X-Tenant-Id': 'creditasbr',
    },
  })
  client.interceptors.request.use(request => requestInterceptor(request))
  return client
}

const partnerApi = partnerApiClient(axios)

export { partnerApi }
